import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './PhotoGallery.css';

const PhotoGallery = ({ images = [], title }) => {
    const renderPhotos = () => {
        return images.map((e, index) => (
            <div key={index}>
                <img src={e} alt={title} />
                <p className={'legend'}>{title}</p>
            </div>
        ));
    };

    return (
        <Carousel width={'100%'} dynamicHeight={true} className={'carousel'}>
            {renderPhotos()}
        </Carousel>
    );
};

export default PhotoGallery;
